export class DepartmentDto {
    keyId: string = '';
    id: string = '';
    parentId: string = '';
    parent?: DepartmentDto;
    code: string = '';
    name: string = '';
    managerId: string = '';
    children?: Array<DepartmentDto>;

    constructor() {
    }
}